import { Routes, Route } from "react-router-dom";
import SoldItemsListingPage from "@/pages/financial/sold-items-listing";

export default function SoldItemsListingRoutes() {
  return (
    <Routes>
      <Route path="/" element={<SoldItemsListingPage />} />
    </Routes>
  );
}
